export function toBase64 (file)  {
  if(!Array.isArray(file))
  {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => resolve(fileReader.result || '');
      fileReader.onerror = err => reject(err);
    });
  }
  else{
    return new Promise((resolve, reject) => {
       resolve(null)
       reject(null)
    });
  }

}
